import React from "react";

import styles from "./colorPreview.scss";

const ColorPreview = ({ color }) => (
  <span className={styles.color} style={{ backgroundColor: color }} />
);

export default ColorPreview;



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleColorSelector/MobileDropdownSelect/SingleSelectModal/ReversedRadio/ColorPreview/index.tsx